module.exports = __webpack_public_path__ + "img/contact98.74f46dba.jpg";